
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/information-technology",
      function () {
        return require("private-next-pages/next/courses/information-technology.tsx");
      }
    ]);
  